// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"5af10ab9","862":"0101d983"}[chunkId] + ".chunk.css";
};